import { createClient } from '@supabase/supabase-js';
import { isRecoveryHash } from '@/lib/passwordReset';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Check .env.local.'
  );
}

// Capturé AVANT createClient : `detectSessionInUrl` consomme puis efface le
// fragment de l'URL, on perdrait sinon l'information que l'utilisateur arrive
// par un lien de réinitialisation de mot de passe et non par une connexion.
export const isPasswordRecoveryLink =
  typeof window !== 'undefined' && isRecoveryHash(window.location.hash);

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
  realtime: {
    params: { eventsPerSecond: 10 },
  },
});
